import React from 'react';

import { EventPerformance, timeData } from '../../models/models';

import EventService from '../../services/event.service';

import config from '../../config/config';

const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;

type EventListItemProps = {
  event: EventPerformance;
}

const MiniEventDetail: React.FC<EventListItemProps> = ({ event }) => {

  const [periodPhrase, setPeriodPhrase] = React.useState<string>('');

  React.useEffect(() => {
    (async () => {
      // strange bug event days and years are sometimes strings but should be numbers instead
      setPeriodPhrase((await EventService.periodPrases({
        day: parseInt(event.day.toString()),              
        month: event.month,
        year: parseInt(event.year.toString()),
        period: event.period
      })).body || '');
      
    })();
  }, []);

  return (
    <li className="flex p-4 shadow-md text-left">
      <div className="flex-shrink-0 w-20 h-20 mr-4">
        <img src={
          (
            event.thumbnail.toUpperCase().startsWith('HTTP://') ||
            event.thumbnail.toUpperCase().startsWith('HTTPS://') ||
            event.thumbnail.toUpperCase().startsWith('www.')
          ) ?
            event.thumbnail
          :
            config.ASSETS[config.ENVIRONMENT] + event.thumbnail
        } alt="Event Thumbnail" className="object-cover w-full h-full rounded" />
      </div>
      <div className="flex-grow">
        { !(event.period === 'Once') &&
          <div className='text-lg font-semibold text-black'>
            { periodPhrase }
            <span className='text-md text-gray-600'>,&nbsp;starting&nbsp;</span>
          </div>
        }
        <div className="flex items-center mb-2 space-x-2">
          <div className="text-lg font-semibold">{event.month} {event.day}, {event.year}</div>
          <div className="text-gray-600">{` at ${event.time}`}</div>
        </div>
        <div className='flex space-x-4 mb-2'>
          <div className="text-lg font-medium text-center">{
              event.website ?
                <a target="_blank" rel="noopener noreferrer" href={event.website}>{event.location}</a>
              :
                event.location
          }</div>
          {
            (!!event.addressa) && (
              <div className="text-blue-800 mt-1">{event.addressa}</div>
            )
          }
          {
            (!!event.addressb) && (
              <div className="text-blue-800 mt-1">{event.addressb}</div>
            )
          }
        </div>

        <div className="text-gray-700 mb-4">{event.description}</div>
        {/* <a href={event.website} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          Learn More
        </a> */}
      </div>
    </li>
  );
};

export default MiniEventDetail;
